"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressBarFill = exports.ProgressBarBar = exports.ProgressBarValue = exports.ProgressBarLabel = exports.ProgressBar = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var react_aria_components_1 = require("react-aria-components");
var theme_1 = require("../theme");
var Form_1 = require("./Forms/Form");
/**
 * A progress bar component that displays a value within a defined range.
 * It provides a visual indicator of progress or completion status.
 *
 * @see {@link https://react-spectrum.adobe.com/react-aria/ProgressBar.html}
 * @see {@link https://compass.circleci.com/?path=/story/rac-progressbar--default}
 *
 * @example
 * ```tsx
 * <ProgressBar value={75} maxValue={100}>
 *   <ProgressBarLabel>Progress</ProgressBarLabel>
 *   <ProgressBarValue />
 *   <ProgressBarBar>
 *     <ProgressBarFill percentage={75} />
 *   </ProgressBarBar>
 * </ProgressBar>
 * ```
 *
 * @param isIndeterminate - Whether presentation is indeterminate when progress isn't known
 * @param formatOptions - The display format of the value label. Defaults to {style: 'percent'}
 * @param valueLabel - The content to display as the value's label (e.g. 1 of 4)
 * @param value - The current value (controlled). Defaults to 0
 * @param minValue - The smallest value allowed for the input. Defaults to 0
 * @param maxValue - The largest value allowed for the input. Defaults to 100
 * @param children - The label, value, and bar components to display
 * @param className - The CSS className for the element
 * @param style - The inline style for the element
 * @param id - The element's unique identifier
 * @param aria-label - Defines a string value that labels the current element
 * @param aria-labelledby - Identifies the element (or elements) that labels the current element
 * @param aria-describedby - Identifies the element (or elements) that describes the object
 * @param aria-details - Identifies the element (or elements) that provide a detailed, extended description for the object
 */
exports.ProgressBar = (0, styled_1.default)(react_aria_components_1.ProgressBar)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: grid;\n  grid-template-areas:\n    'label value'\n    'bar bar';\n  grid-template-columns: 1fr auto;\n  gap: 4px;\n  width: 250px;\n  color: ", ";\n"], ["\n  display: grid;\n  grid-template-areas:\n    'label value'\n    'bar bar';\n  grid-template-columns: 1fr auto;\n  gap: 4px;\n  width: 250px;\n  color: ", ";\n"])), theme_1.theme.colors.n900);
/**
 * A label component for the progress bar.
 * Must be used within a ProgressBar component.
 *
 * @example
 * ```tsx
 * <ProgressBarLabel>Progress</ProgressBarLabel>
 * ```
 *
 * @param children - The label text to display
 */
exports.ProgressBarLabel = (0, styled_1.default)(Form_1.Label)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  grid-area: label;\n"], ["\n  grid-area: label;\n"])));
/**
 * A value component that displays the current progress value.
 * Must be used within a ProgressBar component.
 *
 * @example
 * ```tsx
 * <ProgressBarValue />
 * ```
 */
exports.ProgressBarValue = styled_1.default.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  grid-area: value;\n  font-size: ", ";\n  line-height: ", ";\n"], ["\n  grid-area: value;\n  font-size: ", ";\n  line-height: ", ";\n"])), theme_1.theme.fontSizes.body, theme_1.theme.lineHeights.body);
/**
 * A bar component that contains the progress fill.
 * Must be used within a ProgressBar component.
 *
 * @example
 * ```tsx
 * <ProgressBarBar>
 *   <ProgressBarFill percentage={75} />
 * </ProgressBarBar>
 * ```
 *
 * @param children - The ProgressBarFill component to display
 */
exports.ProgressBarBar = styled_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  grid-area: bar;\n  box-shadow: inset 0px 0px 0px 1px ", ";\n  forced-color-adjust: none;\n  height: 10px;\n  border-radius: 5px;\n  overflow: hidden;\n"], ["\n  grid-area: bar;\n  box-shadow: inset 0px 0px 0px 1px ", ";\n  forced-color-adjust: none;\n  height: 10px;\n  border-radius: 5px;\n  overflow: hidden;\n"])), theme_1.theme.colors.n300);
/**
 * A fill component that represents the progress value.
 * Must be used within a ProgressBarBar component.
 *
 * @example
 * ```tsx
 * <ProgressBarFill percentage={75} />
 * ```
 *
 * @param percentage - The percentage of progress to display (0-100)
 */
exports.ProgressBarFill = styled_1.default.div(function (_a) {
    var percentage = _a.percentage;
    return "\n    width: ".concat(percentage, "%;\n    background: ").concat(theme_1.theme.colors.actionPrimary, ";\n    height: 100%;\n");
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=ProgressBar.js.map